import React, { useCallback, useEffect, useRef, useState } from "react";
// prettier-ignore
import { Grid, Typography, Snackbar, Button, FormControl, InputLabel, Select, MenuItem, Box, CircularProgress, Backdrop, Menu, useTheme, useMediaQuery } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { SchedulerTheme } from "./SchedulerTheme";
import { usePromotionsStyles } from "../styles/PromotionsFormStyles";
import { ViewState } from "@devexpress/dx-react-scheduler";
import {
    Scheduler,
    WeekView,
    Appointments,
    Toolbar,
    ViewSwitcher,
    DayView,
    DateNavigator,
    TodayButton,
    AppointmentTooltip
} from "@devexpress/dx-react-scheduler-material-ui";
import _ from "lodash";
import withStyles from "@mui/styles/withStyles";
import makeStyles from "@mui/styles/makeStyles";
import AddIcon from "@mui/icons-material/Add";
import { FormHeading } from "../utils/CommonComonents/FormHeading";
import {
    getBookingsList,
    _getAvailability
} from "./../modules/ScheduleService";
import {
    startOfWeek,
    endOfWeek,
    differenceInMinutes,
    isSameDay,
    addMinutes
} from "date-fns";
import { graphql, graphqlOperation } from "../modules/AmplifyServices";
import { getUnavailabilityOfProviderScheduleList } from "./../modules/ScheduleService";
import { getProviderExtended } from "../queries/ProviderAddEditQueries";
import { getUserFromCache, userHasProviderOnlyRole } from "../user/UserCommon";
import { RRule } from "rrule";
import { execReadByPK } from "../modules/DBService";
import * as queries from "../graphql/queries";
import * as mutations from "../graphql/mutations";
import AdhocBookingFlow from "./AdhocBookingFlow";
import { LayoutDialog } from "../components/LayoutDialog";
import { useAtom } from "jotai";
import { DialogTheme } from "../styles/DialogTheme";
import {
    customizeDate,
    getCurrentTimeAdjustedToNextHour
} from "../utils/SchedulerFunctions/DateNavigatorFormatter";
import moment from "moment-timezone";
import {
    getMasterTimezone,
    timezoneConversionUserToLoc
} from "../utils/CalendarFunctions/timezoneFunctions";
import { getTimezoneIdByGeoLoc } from "../modules/TimeService";
import SmallSizedModal from "../utils/UI/SmallSizedModal";
import WarningTriangleIcon from "../images/WarningTriangleIcon.svg";
import BlockedTimeModal from "../user/components/BlockedTimeModal";
import {
    mbxUserAtom,
    isMbxUserProvider,
    suggestionsEnabledAtom,
    companyAtom,
    companyProviderRestrictionConfigAtom,
    isMbxUserVerifiedStaff,
    isMbxUserClient,
    companyCollectsPaymentAtom,
    allGroupServicesAtom
} from "../atoms/atoms";
import { selectedBuIdAtom, allBlockedTimesAtom } from "../atoms/blockedTime";
import { selectedUserIdAtom, userPageSnackbarAtom } from "../atoms/usersTable";
import uuid from "uuid/v4";
import { humanizeTime } from "../components/SuggestedTime";
import TravelTimeIcon from "../utils/CommonComponents/TravelTimeIcon";
import {
    setBookingDateTimeAtom,
    setBookingProviderIdAtom,
    setDetailAtom,
    showBookingDetailsAtom
} from "../atoms/booking";
import { useLocation } from "react-router-dom";
import {
    colors,
    GOOGLE_CAL_INTEGRATION_ID,
    MB_SERVICE_CLASSIFICATION_GROUP
} from "../utils/Constants";
import {
    extractCity,
    formatDate,
    formatDaysFromRRule,
    jsonParse
} from "../utils";
import NotificationSnackbar from "../components/NotificationSnackbar";
import { selectedCourseBookingAtom } from "../atoms/course";
import CourseManifestModal from "../user/components/CourseManifestModal";
import { find } from "lodash";
import { parseRRule } from "../modules/RecurringBookingsUtilityFunctions";
import { doesBlockOverlapWithCalendarWeek } from "../utils/scheduleUtils";

const BLOCK_TYPE_TRAVEL_TIME = "travelTime";
const bookedTimeColor = "#0087EE";
const timeOptions = {
    timeStyle: "short"
};

const styles = ({ theme }) => ({
    text: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    content: {
        opacity: 0.8
    },
    container: {
        width: "100%",
        lineHeight: 1.2,
        height: "100%",
        display: "none"
    }
});
const useTooltipContentStyles = makeStyles((theme) => ({
    content: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        gap: "12px",
        padding: "18px",
        backgroundColor: theme.palette.background.paper,
        boxSizing: "border-box",
        width: "400px"
    },
    text: {
        ...theme.typography.body2,
        display: "inline-block"
    },
    title: {
        ...theme.typography.h6,
        color: theme.palette.text.secondary,
        fontWeight: theme.typography.fontWeightBold,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "normal"
    },
    container: {
        paddingBottom: theme.spacing(1.5)
    }
}));

const checkForAvailabilityAndBlocked = (
    rule,
    block_sDate,
    data_sDate,
    data_eDate
) => {
    if (!rule.options.byweekday) {
        if (rule.options.freq === 2) {
            if (block_sDate >= data_sDate && block_sDate < data_eDate) {
                return true;
            } else {
                return false;
            }
        }

        if (rule.options.freq === 3) {
            const until = new Date(rule.options.until);
            const a_hours = new Date(data_sDate).getHours();
            const a_mins = new Date(data_sDate).getMinutes();

            const b_hours = new Date(data_eDate).getHours();
            const b_mins = new Date(data_eDate).getMinutes();

            const block_top = new Date(block_sDate);
            block_top.setHours(Number(a_hours), Number(a_mins));

            let block_bottom = new Date(block_sDate);
            block_bottom.setHours(Number(b_hours), Number(b_mins));

            if (b_hours < a_hours) {
                const startOfDay = new Date(block_sDate);
                startOfDay.setHours(0, 0, 0);
                const endOfDay = new Date(block_sDate);
                endOfDay.setDate(startOfDay.getDate() + 1);
                endOfDay.setHours(0, 0, 0);

                if (
                    block_sDate < until &&
                    ((block_sDate >= startOfDay &&
                        block_sDate < block_bottom) ||
                        (block_sDate >= block_top && block_sDate < endOfDay))
                ) {
                    return true;
                } else return false;
            }

            if (
                block_sDate < until &&
                block_sDate >= data_sDate &&
                block_sDate >= block_top &&
                block_sDate < block_bottom
            ) {
                return true;
            } else {
                return false;
            }
        }
    }

    if (rule.options.byweekday) {
        if (block_sDate < data_sDate) {
            return false;
        }

        const until = new Date(rule.options.until);
        const daysAvail = rule.options.byweekday
            .map((num) => (num === 7 ? 0 : num + 1))
            .join(",");

        const a_hours = new Date(data_sDate).getHours();
        const a_mins = new Date(data_sDate).getMinutes();

        const b_hours = new Date(data_eDate).getHours();
        const b_mins = new Date(data_eDate).getMinutes();

        const block_top = new Date(block_sDate);
        block_top.setHours(Number(a_hours), Number(a_mins));

        let block_bottom = new Date(block_sDate);
        block_bottom.setHours(Number(b_hours), Number(b_mins));

        let isDayAvail = daysAvail.includes(
            block_sDate.getDay() === 0 ? 7 : block_sDate.getDay()
        );

        if (b_hours < a_hours) {
            const startOfDay = new Date(block_sDate);
            startOfDay.setHours(0, 0, 0);
            const endOfDay = new Date(block_sDate);
            endOfDay.setDate(startOfDay.getDate() + 1);
            endOfDay.setHours(0, 0, 0);

            if (
                isDayAvail &&
                block_sDate < until &&
                ((block_sDate >= startOfDay && block_sDate < block_bottom) ||
                    (block_sDate >= block_top && block_sDate < endOfDay))
            ) {
                return true;
            } else return false;
        }

        if (
            isDayAvail &&
            block_sDate < until &&
            block_top <= block_sDate &&
            block_sDate < block_bottom
        ) {
            return true;
        } else {
            return false;
        }
    }
};

const checkForPending = (block_sDate, data_sDate, data_eDate) => {
    if (block_sDate >= data_sDate && block_sDate < data_eDate) {
        return true;
    }

    return false;
};

const checkForBooking = (block_sDate, data_sDate, data_eDate) => {
    if (block_sDate >= data_sDate && block_sDate < data_eDate) {
        return true;
    }

    return false;
};

const Appointment = ({
    children,
    style,
    changeDateTimeCellProps,
    openBlockModalHandler,
    openCourseManifest,
    onClick,
    data,
    cellDuration,
    ...restProps
}) => {
    const [, setSelectedBuId] = useAtom(selectedBuIdAtom);
    const [, setSelectedCourseBooking] = useAtom(selectedCourseBookingAtom);
    if (data.type === BLOCK_TYPE_TRAVEL_TIME) {
        style = {
            backgroundColor: colors.MB_GREY_MEDIUM,
            borderColor: colors.MB_BODY_COLOR_MAIN,
            borderStyle: "dashed",
            borderRadius: "10px"
        };
    } else {
        let background;
        let border = "1px #fff solid";
        if (
            !data.servicetype.id &&
            data.servicetype.name === "Pending Booking" &&
            data.MetaData?.origin !== GOOGLE_CAL_INTEGRATION_ID
        ) {
            background = "rgba(0, 135, 238, 0.5)"; //pendingTimeColor;
        }
        if (data.MetaData?.origin === GOOGLE_CAL_INTEGRATION_ID) {
            background = colors.MB_INFO_COLOR_MAIN;
        }
        if (!data.servicetype.id && data.servicetype.name === "Blocked") {
            if (data.courseId) background = colors.MB_COURSE_SESSION_CALENDAR;
            else background = colors.MB_GREY_MEDIUM;
        }

        if (data.servicetype.id && data.servicetype.name) {
            background = data.courseInfo
                ? colors.MB_COURSE_SESSION_CALENDAR
                : bookedTimeColor;
        }

        style = {
            border,
            backgroundColor: background,
            borderRadius: "10px",
            bottom: localStorage.displayCalendarAs === "Week" ? "2px" : "0px",
            right: "2px"
        };
    }

    return (
        <Appointments.Appointment
            {...restProps}
            data={data}
            style={style}
            cellDuration={cellDuration}
            onClick={
                data.type === BLOCK_TYPE_TRAVEL_TIME
                    ? null
                    : (e) => {
                          if (data.servicetype.name === "Blocked") {
                              if (!data.courseId) {
                                  const buId = data.scheduleinfo.split("|")[3];
                                  changeDateTimeCellProps(
                                      data?.startDate,
                                      data?.providerId,
                                      data?.locationId
                                  );
                                  setSelectedBuId(buId);
                                  openBlockModalHandler();
                              }
                          } else if (data.courseInfo) {
                              setSelectedCourseBooking(data);
                              openCourseManifest(true);
                          } else {
                              onClick(e);
                          }
                      }
            }
        >
            {children}
        </Appointments.Appointment>
    );
};

const AppointmentContent = withStyles(styles, { name: "AppointmentContent" })(({
    classes,
    data,
    cellDuration,
    getCourseCapacityMessage,
    getCourseName,
    ...restProps
}) => {
    const [providerRestrictionConfig] = useAtom(
        companyProviderRestrictionConfigAtom
    );
    const blockLength = differenceInMinutes(data.endDate, data.startDate);
    const lettersInBlock = (40 * blockLength) / cellDuration;
    const [isVerifiedStaff] = useAtom(isMbxUserVerifiedStaff);
    const [isUserProvider] = useAtom(isMbxUserProvider);

    return (
        <Appointments.AppointmentContent
            {...restProps}
            data={data}
            style={
                data.type === BLOCK_TYPE_TRAVEL_TIME ? { height: "100%" } : null
            }
        >
            {data.type === BLOCK_TYPE_TRAVEL_TIME ? (
                <TravelTimeBlockContent {...restProps} data={data} />
            ) : (
                <Box display={"flex"} flexDirection={"column"}>
                    {data.servicetype && data.servicetype.name === "Blocked" ? (
                        <>
                            {!data.courseId ? (
                                <Typography
                                    fontWeight={400}
                                    fontSize={"0.7rem"}
                                    textOverflow={"ellipsis"}
                                    overflow={"hidden"}
                                    whiteSpace={"nowrap"}
                                >
                                    TIME BLOCK
                                </Typography>
                            ) : null}

                            {data.MetaData?.origin ===
                            GOOGLE_CAL_INTEGRATION_ID ? (
                                <Typography
                                    fontWeight={400}
                                    fontSize={"0.7rem"}
                                    textOverflow={"ellipsis"}
                                    overflow={"hidden"}
                                    whiteSpace={"nowrap"}
                                >
                                    "GOOGLE"
                                </Typography>
                            ) : null}
                            {data.courseId ? (
                                <Typography
                                    fontWeight={400}
                                    fontSize={"0.7rem"}
                                    textOverflow={"ellipsis"}
                                    overflow={"hidden"}
                                    whiteSpace={"nowrap"}
                                >
                                    {`Class ${data.sessionNo} of ${data.numberOfSessions}`}
                                </Typography>
                            ) : null}

                            {data.courseId ? (
                                <Typography
                                    fontWeight={400}
                                    fontSize={"0.7rem"}
                                    textOverflow={"ellipsis"}
                                    overflow={"hidden"}
                                    whiteSpace={"nowrap"}
                                >
                                    {getCourseName(data.courseId)}
                                </Typography>
                            ) : null}

                            <Typography
                                fontWeight={400}
                                fontSize={"0.7rem"}
                                textOverflow={"ellipsis"}
                                overflow={"hidden"}
                                whiteSpace={"nowrap"}
                            >{`${data.startDate.toLocaleTimeString(
                                "en-US",
                                timeOptions
                            )} - ${data.endDate.toLocaleTimeString(
                                "en-US",
                                timeOptions
                            )}`}</Typography>
                            {data.courseId ? (
                                <Typography
                                    fontWeight={400}
                                    fontSize={"0.7rem"}
                                    textOverflow={"ellipsis"}
                                    overflow={"hidden"}
                                    whiteSpace={"nowrap"}
                                >
                                    {getCourseCapacityMessage(data.courseId)}
                                </Typography>
                            ) : null}
                            <Typography
                                fontSize={"0.7rem"}
                                fontWeight={400}
                                sx={{ textWrap: "auto" }}
                            >
                                {typeof data.notes === "string" &&
                                    data.notes !== "" && (
                                        <i>{`"${data.notes.substring(0, lettersInBlock)}${data.notes.length > lettersInBlock ? "..." : ""}"`}</i>
                                    )}
                            </Typography>
                        </>
                    ) : (
                        <>
                            <Typography
                                fontWeight={400}
                                fontSize={"0.7rem"}
                                textOverflow={"ellipsis"}
                                overflow={"hidden"}
                                whiteSpace={"nowrap"}
                            >
                                {data.courseInfo
                                    ? `Class ${data.courseInfo.sessionNo} of ${data.courseInfo.numberOfSessions}`
                                    : data.clientName
                                      ? isVerifiedStaff
                                          ? data.clientName
                                          : isUserProvider &&
                                              providerRestrictionConfig.canProviderSeeClientName
                                            ? data.clientName
                                            : `${data.client.user.firstname} ${data.client.user.lastname.trim().charAt(0) + "."}`
                                      : null}
                                {data.MetaData?.eventTitle
                                    ? data.MetaData?.eventTitle
                                    : null}
                            </Typography>
                            <Typography
                                fontSize={"0.7rem"}
                                fontWeight={400}
                                color={(theme) => theme.palette.common.white}
                                textOverflow={"ellipsis"}
                                overflow={"hidden"}
                                whiteSpace={"nowrap"}
                            >
                                {data.MetaData?.origin ===
                                GOOGLE_CAL_INTEGRATION_ID
                                    ? "GOOGLE"
                                    : data.servicetype
                                      ? data.servicetype.name
                                      : ""}
                            </Typography>
                            <Typography
                                fontWeight={400}
                                fontSize={"0.7rem"}
                                textOverflow={"ellipsis"}
                                overflow={"hidden"}
                                whiteSpace={"nowrap"}
                            >
                                {`${data.startDate.toLocaleTimeString(
                                    "en-US",
                                    timeOptions
                                )} - ${data.endDate.toLocaleTimeString(
                                    "en-US",
                                    timeOptions
                                )}`}
                            </Typography>
                            {data.courseInfo && data.courseInfo.seats ? (
                                <Typography
                                    fontWeight={400}
                                    fontSize={"0.7rem"}
                                    color={(theme) =>
                                        data.servicetype.name === "Blocked"
                                            ? theme.palette.common.black
                                            : theme.palette.common.white
                                    }
                                    textOverflow={"ellipsis"}
                                    overflow={"hidden"}
                                    whiteSpace={"nowrap"}
                                >
                                    {`${data.courseInfo.seats.used} / ${data.courseInfo.seats.total} spots booked`}
                                </Typography>
                            ) : (
                                <Typography
                                    fontWeight={400}
                                    fontSize={"0.7rem"}
                                    color={(theme) =>
                                        data.servicetype.name === "Blocked"
                                            ? theme.palette.common.black
                                            : theme.palette.common.white
                                    }
                                    textOverflow={"ellipsis"}
                                    overflow={"hidden"}
                                    whiteSpace={"nowrap"}
                                >
                                    {`${data.location ? data.location : ""}`}
                                </Typography>
                            )}
                        </>
                    )}
                </Box>
            )}
        </Appointments.AppointmentContent>
    );
});

const TravelTimeBlockContent = ({ data }) => {
    return (
        <Box
            sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}
        >
            <Typography
                fontSize={"0.75rem"}
                textOverflow={"ellipsis"}
                overflow={"hidden"}
                whiteSpace={"nowrap"}
                color={(theme) => theme.palette.text.secondary}
            >
                <TravelTimeIcon
                    sx={{
                        marginRight: 1,
                        fontSize: "3.5em",
                        color: (theme) => theme.palette.text.secondary,
                        height: "initial"
                    }}
                />
                {humanizeTime(data.travelTime)}
            </Typography>
        </Box>
    );
};

const AppointmentTooltipHeader = withStyles(styles, {
    name: "Header"
})(({ children, appointmentData, classes, ...restProps }) => {
    return (
        <AppointmentTooltip.Header
            {...restProps}
            style={{
                backgroundColor: appointmentData.company.primaryColor
            }}
            appointmentData={appointmentData}
        ></AppointmentTooltip.Header>
    );
});

const AppointmentTooltipContent = ({
    appointmentData,
    formatDate,
    children
}) => {
    const [providerRestrictionConfig] = useAtom(
        companyProviderRestrictionConfigAtom
    );
    const [isVerifiedStaff] = useAtom(isMbxUserVerifiedStaff);
    const [showFullText, setShowFullText] = useState(false);
    const classes = useTooltipContentStyles({
        color: appointmentData.company.primaryColor
    });
    const handleFullTextToggle = () => {
        setShowFullText(!showFullText);
    };

    return (
        <div className={classes.content}>
            <Grid item container direction={"column"}>
                {appointmentData.clientName &&
                    (isVerifiedStaff ? (
                        <Grid item>{appointmentData.clientName}</Grid>
                    ) : userHasProviderOnlyRole() ? (
                        providerRestrictionConfig.canProviderSeeClientName ? (
                            <Grid item>{appointmentData.clientName}</Grid>
                        ) : (
                            <Grid item>
                                {`${appointmentData.client?.user.firstname} ${appointmentData.client?.user.lastname.trim().charAt(0) + "."}`}
                            </Grid>
                        )
                    ) : null)}

                {appointmentData.client?.user.emailaddress &&
                    (isVerifiedStaff ? (
                        <Grid item>
                            {appointmentData.client?.user.emailaddress}
                        </Grid>
                    ) : userHasProviderOnlyRole() ? (
                        providerRestrictionConfig.canProviderSeeClientEmail ? (
                            <Grid item>
                                {appointmentData.client?.user.emailaddress}
                            </Grid>
                        ) : null
                    ) : null)}

                {appointmentData.client?.user.mobilephone &&
                    (isVerifiedStaff ? (
                        <Grid item>
                            {appointmentData.client?.user.mobilephone}
                        </Grid>
                    ) : userHasProviderOnlyRole() ? (
                        providerRestrictionConfig.canProviderSeeClientPhone ? (
                            <Grid item>
                                {appointmentData.client?.user.mobilephone}
                            </Grid>
                        ) : null
                    ) : null)}
                {appointmentData.MetaData && appointmentData.MetaData.eventTitle
                    ? appointmentData.MetaData.eventTitle
                    : null}
            </Grid>

            <Grid item>
                <div className={classes.text}>
                    {appointmentData.startDate.toLocaleTimeString(
                        "en-US",
                        timeOptions
                    ) === "11:00 AM" &&
                    appointmentData.endDate.toLocaleTimeString(
                        "en-US",
                        timeOptions
                    ) === "12:00 PM"
                        ? `${appointmentData.startDate.toLocaleTimeString(
                              "en-US",
                              timeOptions
                          )} - 
                            ${appointmentData.endDate.toLocaleTimeString(
                                "en-US",
                                timeOptions
                            )}`
                        : `${appointmentData.startDate
                              .toLocaleTimeString("en-US", timeOptions)
                              .replace(/AM|PM/, "")} –
                            ${appointmentData.endDate
                                .toLocaleTimeString("en-US", timeOptions)
                                .replace(/AM|PM/, "")}`}
                </div>
            </Grid>

            <Grid item>
                <div>
                    {appointmentData.MetaData &&
                    appointmentData.MetaData.origin ===
                        GOOGLE_CAL_INTEGRATION_ID
                        ? "GOOGLE"
                        : appointmentData.servicetype
                          ? appointmentData.servicetype.name
                          : ""}
                </div>
            </Grid>
            <Grid item>
                <div>
                    {formatDate(appointmentData.startDate, {
                        dateStyle: "full"
                    })}
                </div>
            </Grid>

            {appointmentData.location && (
                <Grid item>
                    <span>{appointmentData.location}</span>
                </Grid>
            )}
            {appointmentData.MetaData?.origin === GOOGLE_CAL_INTEGRATION_ID &&
                appointmentData.MetaData?.address && (
                    <Grid item>
                        <span>{appointmentData.MetaData.address}</span>
                    </Grid>
                )}
            <Grid item>
                {appointmentData?.order?.Notes ? (
                    <span
                        style={{
                            whiteSpace: "pre-line"
                        }}
                    >
                        {
                            //checking if notes length is greater than 93 characters
                            JSON.parse(appointmentData.order.Notes)[0].notes
                                .length > 93 ? (
                                <>
                                    {showFullText ? (
                                        <>
                                            {
                                                JSON.parse(
                                                    appointmentData.order.Notes
                                                )[0].notes
                                            }
                                            <Button
                                                onClick={handleFullTextToggle}
                                                style={{
                                                    textTransform: "lowercase"
                                                }}
                                            >
                                                ... less
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            {JSON.parse(
                                                appointmentData.order.Notes
                                            )[0].notes.slice(0, 94)}
                                            <Button
                                                onClick={handleFullTextToggle}
                                                style={{
                                                    textTransform: "lowercase"
                                                }}
                                            >
                                                ... more
                                            </Button>
                                        </>
                                    )}
                                </>
                            ) : (
                                // if notes length is less then 93, then dont show more/less buttons
                                <>
                                    {
                                        JSON.parse(
                                            appointmentData.order.Notes
                                        )[0].notes
                                    }
                                </>
                            )
                        }
                    </span>
                ) : appointmentData?.Notes ? ( //this section checks to see if initial booking notes exist.
                    <span //the appointmentData.order.Notes is only populated after editing a note once
                        style={{
                            whiteSpace: "pre-line"
                        }}
                    >
                        {
                            //checking if notes length is greater than 93 characters
                            JSON.parse(appointmentData.Notes)[0].notes.length >
                            93 ? (
                                <>
                                    {showFullText ? (
                                        <>
                                            {
                                                JSON.parse(
                                                    appointmentData.Notes
                                                )[0].notes
                                            }
                                            <Button
                                                onClick={handleFullTextToggle}
                                                style={{
                                                    textTransform: "lowercase"
                                                }}
                                            >
                                                ... less
                                            </Button>
                                        </>
                                    ) : (
                                        <>
                                            {JSON.parse(
                                                appointmentData.Notes
                                            )[0].notes.slice(0, 94)}
                                            <Button
                                                onClick={handleFullTextToggle}
                                                style={{
                                                    textTransform: "lowercase"
                                                }}
                                            >
                                                ... more
                                            </Button>
                                        </>
                                    )}
                                </>
                            ) : (
                                // if notes length is less then 93, then dont show more/less buttons
                                <>
                                    {JSON.parse(appointmentData.Notes)[0].notes}
                                </>
                            )
                        }
                    </span>
                ) : (
                    <span>No notes</span>
                )}
            </Grid>

            {appointmentData?.servicetype?.name === "Blocked" && (
                <Grid container item xs={12} justifyContent={"flex-end"}>
                    <Button
                        variant={"contained"}
                        sx={{ textTransform: "uppercase" }}
                        onClick={() => console.log("edit mode")}
                    >
                        Edit
                    </Button>
                </Grid>
            )}
        </div>
    );
};

const CustomTimeTableCell = ({
    startDate,
    endDate,
    timeTableData,
    openDialog,
    provider,
    settingCellProps,
    fromPath,
    openBlockModalHandler,
    openWarningModal,
    closeWarningModal,
    showWarningModal,
    locationId,
    locations,
    ...otherProps
}) => {
    const theme = useTheme();
    const [isHovered, setIsHovered] = useState(false);
    const [isVerifiedStaff] = useAtom(isMbxUserVerifiedStaff);
    const [isUserProvider] = useAtom(isMbxUserProvider);
    const [isUserClient] = useAtom(isMbxUserClient);
    const [companyCollectsPayment] = useAtom(companyCollectsPaymentAtom);
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"), {
        defaultMatches: true
    });

    const [anchorEl, setAnchorEl] = useState(null);

    let isAvailable = false;

    let style = {
        backgroundColor: "rgba(0,0,0,0.2)",
        cursor: "pointer"
    }; // default

    if (timeTableData.availability && timeTableData.availability.length > 0) {
        for (const ruleObj of timeTableData.availability) {
            const rule = RRule.fromString(ruleObj.rRule);
            if (
                checkForAvailabilityAndBlocked(
                    rule,
                    startDate,
                    ruleObj.startDate,
                    ruleObj.endDate
                )
            ) {
                isAvailable = true;
                style = {
                    backgroundColor: isHovered
                        ? "rgba(0, 135, 238,0.5)"
                        : "white",
                    cursor: "pointer"
                };
                break;
            }
        }
    }

    const checkForBlocked = () => {
        let isBlocked = false;

        if (timeTableData.blockedData && timeTableData.blockedData.length > 0) {
            for (const ruleObj of timeTableData.blockedData) {
                if (ruleObj.servicetype.name === "Blocked") {
                    const rule = RRule.fromString(ruleObj.rRule);

                    if (
                        checkForAvailabilityAndBlocked(
                            rule,
                            startDate,
                            ruleObj.startDate,
                            ruleObj.endDate
                        )
                    ) {
                        isBlocked = true;
                        break;
                    }
                }
            }
        }
        return isBlocked;
    };

    const checkForBookings = () => {
        let isBooked = false;
        if (timeTableData.bookedData && timeTableData.bookedData.length > 0) {
            for (const booking of timeTableData.bookedData) {
                if (booking.servicetype.id) {
                    if (
                        startDate >= new Date(booking.startDate) &&
                        endDate <= new Date(booking.endDate)
                    ) {
                        isBooked = true;
                        break;
                    }
                }

                if (booking.servicetype.name === "Pending Booking") {
                    if (
                        checkForPending(
                            startDate,
                            booking.startDate,
                            booking.endDate
                        )
                    ) {
                        isBooked = true;
                        break;
                    }
                }
            }
        }

        return isBooked;
    };

    const openModal = () => {
        if (provider === undefined) {
            settingCellProps({
                startDate,
                endDate,
                timeTableData,
                openDialog,
                provider,
                locationId,

                ...otherProps
            });
            // setShowSnackMsg(true);
        } else if (provider) {
            settingCellProps({
                startDate,
                endDate,
                timeTableData,
                openDialog,
                provider,
                locationId,
                ...otherProps
            });
            openDialog();
        }
    };
    const { search } = useLocation();
    const [, setBookingProviderId] = useAtom(setBookingProviderIdAtom);
    const [, setBookingDateTime] = useAtom(setBookingDateTimeAtom);

    const searchParams = new URLSearchParams(search);
    const booking = searchParams.get("feature");
    const cellClickHandler = (e) => {
        if (
            isDesktop &&
            isAvailable &&
            !checkForBlocked() &&
            !checkForBookings()
        ) {
            setBookingDateTime(startDate);
            setBookingProviderId(provider?.id);
            const foundLocation = find(locations, { id: locationId });
            if (foundLocation && foundLocation.maxtraveltype) {
                setDetail({
                    selectedLocationId: "customerLocation"
                });
            } else {
                setDetail({
                    selectedLocationId: locationId
                });
            }
            setShowBookingDetails(true);
        }

        if (
            isDesktop &&
            !isAvailable &&
            !checkForBlocked() &&
            !checkForBookings() &&
            isVerifiedStaff
        ) {
            settingCellProps({
                startDate,
                endDate,
                timeTableData,
                openDialog,
                provider,
                locationId,
                ...otherProps
            });
            openWarningModal();
        }
    };
    const [, setDetail] = useAtom(setDetailAtom);
    const addAppointmentHandler = (e) => {
        if (isAvailable && !checkForBlocked() && !checkForBookings()) {
            //put change here
            setBookingDateTime(startDate);
            setBookingProviderId(provider?.id);
            const foundLocation = find(locations, { id: locationId });
            if (foundLocation && foundLocation.maxtraveltype) {
                setDetail({
                    selectedLocationId: "customerLocation"
                });
            } else {
                setDetail({
                    selectedLocationId: locationId
                });
            }
            setShowBookingDetails(true);
            handleClose();
        }
    };

    const addBlockTimeHandler = () => {
        if (isAvailable) {
            settingCellProps({
                startDate
            });
            openBlockModalHandler();
            handleClose();
        }
    };
    const [, setShowBookingDetails] = useAtom(showBookingDetailsAtom);

    const handleClick = (event) => {
        if (isAvailable && !checkForBlocked() && !checkForBookings()) {
            if (isUserProvider) {
                addBlockTimeHandler();
            }

            if (isVerifiedStaff) {
                setAnchorEl(event.currentTarget);
            }
        }
        if (
            !isAvailable &&
            !checkForBlocked() &&
            !checkForBookings() &&
            isVerifiedStaff
        ) {
            openWarningModal();
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <WeekView.TimeTableCell
                onClick={
                    fromPath === "ProviderSchedule"
                        ? handleClick
                        : cellClickHandler
                }
                onMouseEnter={() =>
                    setIsHovered(
                        isAvailable && !checkForBlocked() && !checkForBookings()
                            ? true
                            : false
                    )
                }
                onMouseLeave={() => setIsHovered(false)}
                style={style}
                {...otherProps}
            />
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                PaperProps={{
                    style: {
                        width: 130,
                        padding: 1
                    }
                }}
            >
                {isVerifiedStaff && (
                    <MenuItem
                        sx={{ fontWeight: 600, color: "rgba(0,0,0,0.8)" }}
                        onClick={addAppointmentHandler}
                    >
                        Appointment
                    </MenuItem>
                )}

                {!isUserClient && (
                    <MenuItem
                        sx={{ fontWeight: 600 }}
                        onClick={addBlockTimeHandler}
                    >
                        Block time
                    </MenuItem>
                )}
            </Menu>
        </>
    );
};

export const AvailabilityDisplay = (props) => {
    const [msgOpen, setMsgOpen] = React.useState(false);
    const [snackMsg, setSnackMsg] = React.useState();
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const feature = searchParams.get("feature");
    const [isVerifiedStaff] = useAtom(isMbxUserVerifiedStaff);
    const [openLayoutDialog, setOpenLayoutDialog] = useState(false);
    const [, setDetail] = useAtom(setDetailAtom);
    const [, setBookingProviderId] = useAtom(setBookingProviderIdAtom);
    const [, setBookingDateTime] = useAtom(setBookingDateTimeAtom);
    const [, setShowBookingDetails] = useAtom(showBookingDetailsAtom);
    const displayEmptyScheduler = props?.displayEmptyScheduler
        ? props.displayEmptyScheduler
        : () => null;
    const displayListProviders = props?.displayListProviders
        ? props.displayListProviders
        : () => [];
    const [currentDate, setCurrentDate] = useState(props.currentDate);
    const [viewName, setViewName] = useState("Week");
    const [locations, setLocations] = useState([]);
    const [selectedLoc, setSelectedLoc] = useState(null);
    const [locationId, setLocationId] = useState(null);
    const [provider, setProvider] = useState();
    const [availabilityData, setAvailabilityData] = useState([]);
    const [bookedData, setBookedData] = useState([]);
    const [filteredbookedData, setFilteredBookedData] = useState([]);
    const [blockedData, setBlockedData] = useState([]);
    const [pendingData, setPendingData] = useState([]);
    const [startWeekDate, setStartWeekDate] = useState(
        startOfWeek(new Date(), { weekStartsOn: 1 })
    );
    const [endWeekDate, setEndWeekDate] = useState(
        endOfWeek(new Date(), { weekStartsOn: 1 })
    );
    const [isLoading, setIsLoading] = useState(false);
    const [fullPageLoad, setFullPageLoad] = useState(true);
    const [openAddBookingDialog, setOpenAddBookingDialog] = useState(false);
    const [bookingCompleted, setBookingCompleted] = useState(false);
    const [showSnackMsg, setShowSnackMsg] = useState(false);
    const [clickedCellProps, setClickedCellProps] = useState();
    const [timeTableData, setTimeTableData] = useState([]);
    const [availabilityError, setAvailabilityError] = useState(false);
    const [, setAllBlockedTimes] = useAtom(allBlockedTimesAtom);
    const [showLocDrop, setShowLocDrop] = useState(true);
    const [showBookBtn, setShowBookBtn] = useState(true);
    const [hasCellDurationValue, setHasCellDurationValue] = useState(false);
    const defaultCalendarSettings = {
        cellDuration: 60,
        excludedDays: [],
        startDayHour: 7,
        endDayHour: 19
    };
    const calendarSettings =
        localStorage.getItem("calendarSettings") || undefined;
    const [cellDuration, setCellDuration] = useState(
        jsonParse(calendarSettings, defaultCalendarSettings)?.cellDuration
    );
    const [excludedDays, setExcludedDays] = useState(
        jsonParse(calendarSettings, defaultCalendarSettings)?.excludedDays
    );
    const [startDayHour, setStartDayHour] = useState(
        jsonParse(calendarSettings, defaultCalendarSettings)?.startDayHour
    );
    const [endDayHour, setEndDayHour] = useState(
        jsonParse(calendarSettings, defaultCalendarSettings)?.endDayHour
    );
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [masterTimezone, setMasterTimezone] = useState(null);
    const [refreshPage, setRefreshPage] = useState(false);
    const [openBlockedTimeDialog, setBlockedTimeDialog] = useState(false);
    const [openCourseManifest, setOpenCourseManifest] = useState(false);
    const [mbxUser] = useAtom(mbxUserAtom);
    const [isUserProvider] = useAtom(isMbxUserProvider);
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up("md"), {
        defaultMatches: true
    });
    const schedulerRef = useRef(null);
    const openWarningModal = () => {
        setShowWarningModal(true);
    };
    const closeWarningModal = () => {
        setShowWarningModal(false);
    };
    const loggedInUser = getUserFromCache();
    if (!hasCellDurationValue) {
        getCellDurationForUser(loggedInUser.id);
    }
    const [suggestionsEnabled] = useAtom(suggestionsEnabledAtom);
    const [allGroupServices] = useAtom(allGroupServicesAtom);
    const [company] = useAtom(companyAtom);
    const [userPageSnackbar, setUserPageSnackMessage] =
        useAtom(userPageSnackbarAtom);
    const {
        open: openSnackbar = false,
        message: snackMessage = "",
        severity: snackSeverity = "success"
    } = userPageSnackbar;
    let calendarStartDate =
        viewName === "Week"
            ? startOfWeek(props.currentDate, { weekStartsOn: 1 })
            : currentDate;

    let calendarEndDate =
        viewName === "Week"
            ? endOfWeek(props.currentDate, { weekStartsOn: 1 })
            : getNextDayDate(currentDate);

    const handleCloseSnackbar = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }

        setUserPageSnackMessage({
            open: false,
            message: snackMsg,
            severity: snackSeverity
        });
    };

    const insertTravelTime = (allBlocks, providerMaxTravelTime) =>
        allBlocks
            .filter(({ title }) => title !== "Blocked") // attach travel times to booking or pending booking
            .sort(
                ({ startDate: startDateA }, { startDate: startDateB }) =>
                    startDateA - startDateB
            )
            .reduce(
                (
                    aggr,
                    { endDate, isVirtual, location, ...rest },
                    index,
                    sortedBlocks
                ) => {
                    const timeTravelBlock = {
                        id: uuid(),
                        type: BLOCK_TYPE_TRAVEL_TIME,
                        title: "Travel Time",
                        startDate: endDate
                    };
                    const diffInMinutes = differenceInMinutes(
                        sortedBlocks[index + 1]?.startDate,
                        endDate
                    );
                    if (
                        // only if there is no overlap
                        sortedBlocks[index + 1] &&
                        sortedBlocks[index + 1].startDate > endDate
                    )
                        if (suggestionsEnabled) {
                            if (
                                isSameDay(
                                    endDate,
                                    sortedBlocks[index + 1]?.startDate
                                ) &&
                                (providerMaxTravelTime || company.travelTime) >=
                                    diffInMinutes &&
                                diffInMinutes !== 0 &&
                                location !== sortedBlocks[index + 1].location
                            ) {
                                aggr.push({
                                    ...timeTravelBlock,
                                    endDate: addMinutes(endDate, diffInMinutes),
                                    travelTime: diffInMinutes
                                });
                            }
                        } else {
                            if (company.travelTime && diffInMinutes !== 0) {
                                aggr.push({
                                    ...timeTravelBlock,
                                    endDate: addMinutes(
                                        endDate,
                                        company.travelTime
                                    ),
                                    travelTime: company.travelTime
                                });
                            }
                        }
                    aggr.push({ endDate, isVirtual, location, ...rest });
                    return aggr;
                },
                []
            )
            .concat(allBlocks.filter(({ title }) => title === "Blocked")); // add blocked times back

    async function getCellDurationForUser(userId) {
        try {
            const exists = await graphql(
                graphqlOperation(queries.getRefData, {
                    refType: `calendercellduration|${userId}`,
                    refName: "data-calendercellduration"
                })
            );

            if (exists.data.getRefData && exists.data.getRefData.refValue) {
                setCellDuration(parseInt(exists.data.getRefData.refValue, 10));
                setHasCellDurationValue(true);
            } else {
                setHasCellDurationValue(false);
            }
        } catch (error) {
            console.error("Error in getCellDurationForUser:", error);
            return false;
        }
    }

    function getCourseCapacityMessage(serviceTypeId) {
        //`0 of ${getCourseCapacity(data.courseId)} spots booked`
        const course = allGroupServices?.find(
            (service) => service.id === serviceTypeId
        );
        if (course && course.CourseSettings) {
            const courseSettings = jsonParse(course.CourseSettings, {});
            if (courseSettings?.capacity)
                return `0 / ${courseSettings.capacity} spots booked`;
        }
        return `0 spots booked`;
    }
    function getCourseName(serviceTypeId) {
        //`0 of ${getCourseCapacity(data.courseId)} spots booked`
        const course = allGroupServices?.find(
            (service) => service.id === serviceTypeId
        );
        if (course) {
            return course.name;
        }
        return "";
    }

    function changeViewName(viewName) {
        setViewName(viewName);
    }

    const LocationIdChangeHandler = async (e) => {
        setIsLoading((prevState) => !prevState);
        setLocationId(e.target.value);

        setSelectedLoc(
            (prev) => locations.filter((item) => item.id === e.target.value)[0]
        );

        // Start loading
        try {
            await getLocationsData(e.target.value);
        } finally {
            setIsLoading((prevState) => !prevState);
        }
    };
    const cellDurationChangeHandler = async (e) => {
        setCellDuration(e);
        try {
            if (hasCellDurationValue) {
                await graphql(
                    graphqlOperation(mutations.updateRefData, {
                        input: {
                            refType: `calendercellduration|${loggedInUser.id}`,
                            refName: "data-calendercellduration",
                            refValue: e
                        }
                    })
                );
            } else {
                await graphql(
                    graphqlOperation(mutations.createRefData, {
                        input: {
                            refType: `calendercellduration|${loggedInUser.id}`,
                            refName: "data-calendercellduration",
                            refValue: e
                        }
                    })
                );
                setHasCellDurationValue(true);
            }
        } catch (error) {
            console.error("Error in chanfing cellDurationForUser:", error);
        }
    };

    const handleExcludedDaysChange = (newExcludedDays) => {
        setExcludedDays(newExcludedDays);
    };

    const handleStartEndTimeChange = (startTimeBoundary, endTimeBoundary) => {
        setStartDayHour(startTimeBoundary);
        setEndDayHour(endTimeBoundary);
    };

    function setWeekDates(date) {
        setStartWeekDate(startOfWeek(date), { weekStartsOn: 1 });
        setEndWeekDate(endOfWeek(date), { weekStartsOn: 1 });
    }

    function currentDateChanged(curDate) {
        setCurrentDate(curDate);
        props.setCurrentDate(curDate);
        setIsLoading(true);
        if (viewName === "Week" || viewName === "Day") setWeekDates(curDate);
    }
    const [, setSelectedUserId] = useAtom(selectedUserIdAtom);

    //helper function to adjust the calendar start time to include out of range Monday block
    //TODO: remove once we replace calendar and introduce full blocks
    const adjustCalendarStartTimeByUnavblocks = (
        unavblocks,
        startDayHour,
        calendarStartDate
    ) => {
        try {
            let earliestHour = startDayHour;
            let foundEarlierBlock = false;

            unavblocks.forEach((block) => {
                const blockStartDate = new Date(block.startDate);

                try {
                    //skip if the block starts after the calendar week starts or
                    //skip if block ends before our calendar week even starts
                    if (
                        !doesBlockOverlapWithCalendarWeek(
                            block,
                            calendarStartDate
                        )
                    ) {
                        setStartDayHour(
                            jsonParse(
                                localStorage.getItem("calendarSettings"),
                                defaultCalendarSettings
                            )?.startDayHour
                        );
                        return;
                    }

                    if (block.rRule) {
                        //check if this block occurs on Mondays
                        const parsedRRule = parseRRule(block.rRule);
                        if (
                            !parsedRRule.days.includes(0) ||
                            blockStartDate > calendarStartDate
                        ) {
                            setStartDayHour(
                                jsonParse(
                                    localStorage.getItem("calendarSettings"),
                                    defaultCalendarSettings
                                )?.startDayHour
                            );
                            return;
                        }
                    } else {
                        //for non-recurring events, just check if it's on Monday
                        if (blockStartDate.getDay() !== 1) {
                            setStartDayHour(
                                jsonParse(
                                    localStorage.getItem("calendarSettings"),
                                    defaultCalendarSettings
                                )?.startDayHour
                            );
                            return;
                        }
                    }

                    if (blockStartDate.getHours() <= earliestHour) {
                        earliestHour = blockStartDate.getHours();
                        foundEarlierBlock = true;
                    }
                } catch (e) {
                    console.error("Error processing block:", block, e);
                }
            });

            if (foundEarlierBlock && earliestHour <= startDayHour) {
                setStartDayHour(earliestHour);
            }

            return earliestHour;
        } catch (e) {
            console.error("Error in adjustCalendarStartTimeByUnavblocks:", e);
            return startDayHour; //return original as fallback
        }
    };

    const fetchBlockedTimes = useCallback(
        async (startDate, endDate, locations) => {
            const companyId = loggedInUser.companyId;
            const company = loggedInUser.company;
            setIsLoading(true);
            const aProvider = await graphql(
                graphqlOperation(getProviderExtended, {
                    id: isUserProvider
                        ? mbxUser.provider.id
                        : props.selectedProviders[0].id
                })
            );
            setProvider(aProvider.data.getProvider);
            setSelectedUserId(
                isUserProvider
                    ? mbxUser.id
                    : props.selectedProviders[0]?.user?.id
            );
            let unavblocks = await getUnavailabilityOfProviderScheduleList(
                {
                    companyId: companyId,
                    provider: aProvider.data.getProvider,
                    startDate: startDate,
                    endDate: endDate
                },
                setAllBlockedTimes
            );

            const totalBlocks = [];
            locations.forEach((location) => {
                unavblocks.forEach((unavblock) => {
                    const newBlock = { ...unavblock };
                    newBlock.locationId = location.id;
                    newBlock.isVirtual = location.virtual;
                    newBlock.id = newBlock.id + location.id;
                    newBlock.blocked = true;
                    newBlock.company = company;
                    totalBlocks.push(newBlock);
                });
            });
            return totalBlocks;
        },
        [props.selectedProviders]
    );
    async function enrichCourseData(bookings) {
        try {
            const [groupedBookings, regularBookings] = bookings.reduce(
                (acc, booking) => {
                    if (booking.courseInfo) {
                        acc[0].push(booking); // Push to the first array (courses bookings)
                    } else {
                        acc[1].push(booking); // Push to the second array (non-courses bookings)
                    }
                    return acc;
                },
                [[], []]
            );
            const uniqeSessionBookings = _.uniqBy(
                groupedBookings,
                "courseInfo.sessionId"
            ); //merged bookings
            // get number of slots booked
            const uniqueSessionsChunks = _.chunk(uniqeSessionBookings, 5);
            const allCourseSessions = {};
            for (const sessionChunk of uniqueSessionsChunks) {
                const results = sessionChunk.map((booking) =>
                    graphql(
                        graphqlOperation(queries.getCourseSession, {
                            serviceTypeId: booking.courseInfo.courseId,
                            sessionId: booking.courseInfo.sessionId
                        })
                    )
                );
                const courseSessions = await Promise.all(results);
                courseSessions.forEach((result) => {
                    if (result.data.getCourseSession?.sessionId)
                        allCourseSessions[
                            result.data.getCourseSession.sessionId
                        ] = result.data.getCourseSession;
                });
            }
            uniqeSessionBookings.forEach((uniqueSessionBooking) => {
                const courseSession =
                    allCourseSessions[
                        uniqueSessionBooking.courseInfo.sessionId
                    ];
                if (courseSession)
                    uniqueSessionBooking.courseInfo.seats = {
                        total: courseSession.maxSeats,
                        used: courseSession.usedSeats
                    };
                else
                    uniqueSessionBooking.courseInfo.seats = {
                        total: 0,
                        used: 0
                    };
            });
            regularBookings.push(...uniqeSessionBookings);
            regularBookings.sort(
                (a, b) => new Date(a.startdate) - new Date(b.startdate)
            );
            return {
                regularBookings,
                uniqueCourseBookings: uniqeSessionBookings
            };
        } catch (e) {
            console.log("error in enrichCourseData", e);
            return [];
        }
    }
    const fetchBookings = useCallback(async (startDate, endDate, locations) => {
        let bkgs = await getBookingsList(
            isUserProvider
                ? mbxUser.provider.id
                : props.selectedProviders[0].id,
            startDate,
            endDate,
            props.selectedProviders[0].timezone
        );
        const totalBlocks = [];
        bkgs.forEach((booking) => {
            if (booking.orderType === MB_SERVICE_CLASSIFICATION_GROUP)
                booking.courseInfo = JSON.parse(booking.MetaData);
        });
        let courseBookingsOfSequence;
        if (bkgs.some((booking) => booking.courseInfo)) {
            const enrichedMergedBookings = await enrichCourseData(bkgs);
            bkgs = enrichedMergedBookings.regularBookings;
            courseBookingsOfSequence =
                enrichedMergedBookings.uniqueCourseBookings;
        }
        bkgs.forEach((item) => {
            const timeBlockIdArray = item.timeblockid.split("|");
            const locationIdArr = timeBlockIdArray.filter(
                (item) => item.startsWith("CL-") || item.startsWith("PL-")
            );
            item.locationId = locationIdArr[0]?.substring(3);
            totalBlocks.push(item);
            // Here, we create a blocked booking for all other locations other than the original booking location
            locations.forEach((curLocation) => {
                if (curLocation.id !== item.locationId) {
                    const blockedBooking = { ...item };
                    blockedBooking.id = blockedBooking.id + curLocation.id;
                    blockedBooking.locationId = curLocation.id;
                    blockedBooking.blocked = true;
                    totalBlocks.push(blockedBooking);
                }
            });
        });
        return { totalBlocks, courseBookingsOfSequence };
    }, []);
    const fetchAvailability = useCallback(
        async (startDate, endDate) => {
            const companyId = loggedInUser.companyId;
            const company = loggedInUser.company;
            const provider = isUserProvider
                ? mbxUser.provider
                : props.selectedProviders[0];
            const maxTravelTime = isUserProvider
                ? mbxUser.provider.maxTravelTime
                : props.selectedProviders[0].maxTravelTime;
            let tz = props?.selectedProviders?.[0]?.timezone;

            let massterTz = await getMasterTimezone();
            setMasterTimezone(massterTz);

            const filter = {
                and: [{ active: { ne: false } }, { deleted: { ne: true } }]
            };

            let providerLocations = await execReadByPK({
                opname: "locationByProvider",
                op: queries.locationByProvider,
                id: { providerId: provider.id },
                filter,
                sortDirection: "DESC"
            });

            let companyLocations = await execReadByPK({
                opname: "companyLocationByCompany",
                op: queries.companyLocationByCompany,
                id: {
                    companyId: companyId
                },
                filter: filter
            });

            let ava = await _getAvailability({
                companyId,
                providerArr: isUserProvider
                    ? [mbxUser.provider]
                    : props.selectedProviders
            });
            ava.availability = ava.availability.filter(
                (avail) => new Date(avail.endDate) >= new Date()
            );
            if (ava && ava.availability && ava.availability.length) {
                setLocations(ava.locations);

                //fetch provider
                const aProvider = await graphql(
                    graphqlOperation(getProviderExtended, {
                        id: isUserProvider
                            ? mbxUser.provider.id
                            : props.selectedProviders[0].id
                    })
                );
                const providerTz = aProvider.data.getProvider.timezone;
                const maxTravelTime = aProvider.data.getProvider.maxTravelTime;
                const blockedTimes = await fetchBlockedTimes(
                    startDate,
                    endDate,
                    ava.locations
                );

                //temporary fix to adjust the calendar start time to include out of range Monday block
                //TODO: remove once we replace calendar and introduce full blocks
                adjustCalendarStartTimeByUnavblocks(
                    blockedTimes,
                    startDayHour,
                    startDate
                );

                let blockedAvail = blockedTimes.filter(
                    (item) => item.servicetype.name === "Blocked"
                );

                let pendingBookings = blockedTimes.filter(
                    (item) => item.servicetype.name === "Pending Booking"
                );

                const mergedBookings = await fetchBookings(
                    startDate,
                    endDate,
                    ava.locations
                );
                const bkgs = mergedBookings.totalBlocks;

                if (
                    blockedAvail &&
                    blockedAvail.length &&
                    mergedBookings.courseBookingsOfSequence &&
                    mergedBookings.courseBookingsOfSequence.length
                ) {
                    //filter out BUTs corresponding to the booked course bookings
                    blockedAvail = blockedAvail.filter((but) => {
                        if (
                            but.MetaData &&
                            but.MetaData[0] &&
                            but.MetaData[0].sequenceId
                        ) {
                            return !mergedBookings.courseBookingsOfSequence.find(
                                (booking) =>
                                    booking.courseInfo?.sequenceId ===
                                    but.MetaData[0].sequenceId
                            );
                        } else if (but.MetaData?.sequenceId) {
                            return !mergedBookings.courseBookingsOfSequence.find(
                                (booking) =>
                                    booking.courseInfo?.sequenceId ===
                                    but.MetaData.sequenceId
                            );
                        }
                        return true;
                    });
                }
                ava.availability.forEach((item) => {
                    item.servicetype = { name: "Availability" };
                    item.company = company;
                });

                const listCompanyData = [
                    ...providerLocations.items,
                    ...companyLocations.items
                ];

                const availabilityMap = {};
                ava.availability.forEach((avail) => {
                    availabilityMap[avail.locationId] = avail;
                });

                const locationsData = Object.keys(availabilityMap);

                const filteredLocations = listCompanyData.filter(
                    (item) => locationsData.includes(item.id) && item
                );

                //transform the location names
                filteredLocations.forEach((location) => {
                    try {
                        const availability = availabilityMap[location.id];
                        if (availability) {
                            const city = extractCity(location.addressoneline);
                            const dateRange = `${formatDate(availability.startDate)} – ${formatDate(availability.endDate)}`;
                            const days = formatDaysFromRRule(
                                availability.rRule
                            );
                            location.name = `${city} | ${dateRange} | ${days}`;
                        }
                    } catch (e) {
                        console.error("Error formatting location name:", e);
                        location.name = "Travel zone";
                    }
                });

                setLocations(filteredLocations);
                setAvailabilityData(ava.availability);
                setBlockedData(blockedAvail);
                setPendingData(pendingBookings);
                setBookedData(bkgs);

                if (!locationId) {
                    if (
                        filteredLocations.length &&
                        filteredLocations[0].id &&
                        filteredLocations[0].id.length > 0
                    ) {
                        setLocationId(filteredLocations[0].id);
                        setSelectedLoc(filteredLocations[0]);
                        let filteredAvail = ava.availability.filter(
                            (item) =>
                                item.locationId === filteredLocations[0].id
                        );

                        let filteredBlock = blockedAvail.filter(
                            (item) =>
                                item.locationId === filteredLocations[0].id
                        );

                        let filteredbookedData = bkgs.filter(
                            (item) =>
                                item.locationId === filteredLocations[0].id
                        );

                        if (
                            filteredbookedData &&
                            filteredbookedData.length > 0
                        ) {
                            filteredbookedData = filteredbookedData.map(
                                (item) => {
                                    if (item.timezone === tz) {
                                        return item;
                                    }

                                    if (item.timezone !== tz) {
                                        // Convert the start date
                                        let s_date =
                                            timezoneConversionUserToLoc(
                                                moment(
                                                    item.startDTStr,
                                                    "MMM DD, YYYY hh:mm A"
                                                ).format("YYYY-MM-DDTHH:mm:00"), // Ensure start date is formatted consistently
                                                item.timezone,
                                                tz
                                            );

                                        // Convert the end date
                                        let e_date =
                                            timezoneConversionUserToLoc(
                                                moment(
                                                    item.endDTStr,
                                                    "MMM DD, YYYY hh:mm A"
                                                ).format("YYYY-MM-DDTHH:mm:00"), // Ensure end date is formatted consistently
                                                item.timezone,
                                                tz
                                            );

                                        // Return the item with updated dates
                                        return {
                                            ...item,
                                            startDate: s_date,
                                            endDate: e_date
                                        };
                                    }
                                }
                            );
                        }

                        let filterPending = pendingBookings.filter(
                            (item) =>
                                item.locationId === filteredLocations[0].id
                        );

                        if (providerTz !== tz) {
                            filterPending = filterPending.map((item) => {
                                let s_date = timezoneConversionUserToLoc(
                                    item.startDate,
                                    providerTz,
                                    tz
                                );
                                let e_date = timezoneConversionUserToLoc(
                                    item.endDate,
                                    providerTz,
                                    tz
                                );
                                return {
                                    ...item,
                                    startDate: s_date,
                                    endDate: e_date
                                };
                            });
                        }

                        setFilteredBookedData(
                            insertTravelTime(
                                [
                                    ...filteredbookedData,
                                    ...filterPending,
                                    ...filteredBlock
                                ],
                                maxTravelTime
                            )
                        );

                        let dataObj = {
                            availability: [...filteredAvail],
                            bookedData: [
                                ...filteredbookedData,
                                ...filterPending
                            ],
                            blockedData: [...filteredBlock]
                        };
                        setTimeTableData(dataObj);
                    }
                } else {
                    setIsLoading(true);

                    let selectedLocation = filteredLocations.filter(
                        (item) => item.id === locationId
                    );
                    let filteredAvail = ava.availability.filter(
                        (item) => item.locationId === locationId
                    );

                    setSelectedLoc(selectedLocation[0]);

                    let filteredBlock = blockedAvail.filter(
                        (item) => item.locationId === locationId
                    );

                    if (providerTz !== tz) {
                        filteredBlock = filteredBlock.map((item) => {
                            let s_date = timezoneConversionUserToLoc(
                                item.startDate,
                                providerTz,
                                tz
                            );
                            let e_date = timezoneConversionUserToLoc(
                                item.endDate,
                                providerTz,
                                tz
                            );
                            return {
                                ...item,
                                startDate: s_date,
                                endDate: e_date
                            };
                        });
                    }

                    let filteredbookedData = bkgs.filter(
                        (item) => item.locationId === locationId
                    );

                    if (filteredbookedData && filteredbookedData.length > 0) {
                        filteredbookedData.forEach((item) => {
                            if (item.timezone === tz) {
                                return item;
                            }

                            if (item.timezone !== tz) {
                                // Convert the start date
                                let s_date = timezoneConversionUserToLoc(
                                    moment(
                                        item.startDTStr,
                                        "MMM DD, YYYY hh:mm A"
                                    ).format("YYYY-MM-DDTHH:mm:00"), // Ensure start date is formatted consistently
                                    item.timezone,
                                    tz
                                );

                                // Convert the end date
                                let e_date = timezoneConversionUserToLoc(
                                    moment(
                                        item.endDTStr,
                                        "MMM DD, YYYY hh:mm A"
                                    ).format("YYYY-MM-DDTHH:mm:00"), // Ensure end date is formatted consistently
                                    item.timezone,
                                    tz
                                );

                                // Return the item with updated dates
                                return {
                                    ...item,
                                    startDate: s_date,
                                    endDate: e_date
                                };
                            }
                        });
                    }

                    let filterPending = pendingBookings.filter(
                        (item) => item.locationId === locationId
                    );

                    if (providerTz !== tz) {
                        filterPending = filterPending.map((item) => {
                            let s_date = timezoneConversionUserToLoc(
                                item.startDate,
                                providerTz,
                                tz
                            );
                            let e_date = timezoneConversionUserToLoc(
                                item.endDate,
                                providerTz,
                                tz
                            );
                            return {
                                ...item,
                                startDate: s_date,
                                endDate: e_date
                            };
                        });
                    }

                    setFilteredBookedData(
                        insertTravelTime(
                            [
                                ...filteredbookedData,
                                ...filterPending,
                                ...filteredBlock
                            ],
                            maxTravelTime
                        )
                    );

                    let dataObj = {
                        availability: [...filteredAvail],
                        bookedData: [...filteredbookedData, ...filterPending],
                        blockedData: [...filteredBlock]
                    };
                    setTimeTableData(dataObj);
                }

                setIsLoading(false);
                setFullPageLoad(false);
            } else {
                let compLocations = companyLocations.items.map((item) => ({
                    isVirtual: item.virtual,
                    id: item.id,
                    text: item.locationname
                }));
                try {
                    setShowLocDrop(false);
                    setShowBookBtn(false);
                    setAvailabilityError(true);
                    let blockedTimes =
                        await getUnavailabilityOfProviderScheduleList(
                            {
                                companyId: loggedInUser.companyId,
                                provider,
                                startDate,
                                endDate
                            },
                            setAllBlockedTimes
                        );
                    if (blockedTimes && blockedTimes.length > 0) {
                        blockedTimes = blockedTimes.map((block) => ({
                            ...block,
                            company: loggedInUser.company
                        }));
                    }

                    setBlockedData(blockedTimes);
                    setFilteredBookedData(
                        insertTravelTime(blockedTimes, maxTravelTime),
                        maxTravelTime
                    );
                    let mergedBookings = await fetchBookings(
                        startDate,
                        endDate,
                        compLocations
                    );
                    let bkgs = mergedBookings.totalBlocks;

                    if (bkgs && bkgs.length > 0) {
                        bkgs = bkgs.filter((item) => {
                            if (!item.id.includes(item.locationId)) {
                                if (item.timezone === tz) {
                                    return item;
                                }

                                if (item.timezone !== tz) {
                                    // Convert the start date
                                    let s_date = timezoneConversionUserToLoc(
                                        moment(
                                            item.startDTStr,
                                            "MMM DD, YYYY hh:mm A"
                                        ).format("YYYY-MM-DDTHH:mm:00"), // Ensure start date is formatted consistently
                                        item.timezone,
                                        tz
                                    );

                                    // Convert the end date
                                    let e_date = timezoneConversionUserToLoc(
                                        moment(
                                            item.endDTStr,
                                            "MMM DD, YYYY hh:mm A"
                                        ).format("YYYY-MM-DDTHH:mm:00"), // Ensure end date is formatted consistently
                                        item.timezone,
                                        tz
                                    );

                                    // Return the item with updated dates
                                    return {
                                        ...item,
                                        startDate: s_date,
                                        endDate: e_date
                                    };
                                }
                            }
                        });

                        setFilteredBookedData(bkgs);
                    }
                    setIsLoading(false);
                } catch (error) {
                    console.log("No Availability Error Fetching", error);
                } finally {
                    setFullPageLoad(false);
                }
                if (isVerifiedStaff) {
                    setSnackMsg(
                        "Currently there is no availability set up for the selected provider."
                    );
                    setMsgOpen(true);
                }
            }
        },
        [locationId]
    );

    useEffect(() => {
        let startDate =
            viewName === "Week"
                ? startOfWeek(props.currentDate, { weekStartsOn: 1 })
                : currentDate;

        let endDate =
            viewName === "Week"
                ? endOfWeek(props.currentDate, { weekStartsOn: 1 })
                : getNextDayDate(currentDate);

        if (startDate && endDate && !bookingCompleted && !refreshPage) {
            fetchAvailability(startDate, endDate);
        }

        if (bookingCompleted) {
            setBookingCompleted(false);
        }

        if (refreshPage) {
            setRefreshPage((prevState) => false);
        }
    }, [
        props.currentDate,
        viewName,
        startWeekDate,
        endWeekDate,
        bookingCompleted,
        refreshPage
    ]);

    const fetchExtendProvider = async (id) => {
        const aProvider = await graphql(
            graphqlOperation(getProviderExtended, {
                id: id
            })
        );
        setProvider(aProvider.data.getProvider);
        setSelectedUserId(aProvider.data.getProvider.user.id);
    };

    useEffect(() => {
        if (
            props.selectedProviders &&
            props.selectedProviders[0] &&
            props.selectedProviders[0].id
        ) {
            fetchExtendProvider(props.selectedProviders[0].id);
        }
    }, [props.selectedProviders]);

    const getLocationsData = async (locId) => {
        //locationId && locationId.length > 0
        if (locId && locId.length > 0) {
            setLocationId(locId);
            let filteredAvail = availabilityData.filter(
                (item) => item.locationId === locId
            );

            let tz = props?.selectedProviders?.[0]?.timezone;

            let filteredBlock = blockedData.filter(
                (item) => item.locationId === locId
            );

            if (tz && provider.timezone !== tz) {
                filteredBlock = filteredBlock.map((item) => {
                    let s_date = timezoneConversionUserToLoc(
                        item.startDate,
                        provider.timezone,
                        tz
                    );
                    let e_date = timezoneConversionUserToLoc(
                        item.endDate,
                        provider.timezone,
                        tz
                    );
                    return {
                        ...item,
                        startDate: s_date,
                        endDate: e_date
                    };
                });
            }
            let filteredbookedData = bookedData.filter(
                (item) => item.locationId === locId
            );

            if (filteredbookedData && filteredbookedData.length > 0) {
                filteredbookedData.forEach((item) => {
                    if (item.timezone === tz) {
                        return item;
                    }

                    if (item.timezone !== tz) {
                        // Convert the start date
                        let s_date = timezoneConversionUserToLoc(
                            moment(
                                item.startDTStr,
                                "MMM DD, YYYY hh:mm A"
                            ).format("YYYY-MM-DDTHH:mm:00"), // Ensure start date is formatted consistently
                            item.timezone,
                            tz
                        );

                        // Convert the end date
                        let e_date = timezoneConversionUserToLoc(
                            moment(
                                item.endDTStr,
                                "MMM DD, YYYY hh:mm A"
                            ).format("YYYY-MM-DDTHH:mm:00"), // Ensure end date is formatted consistently
                            item.timezone,
                            tz
                        );

                        // Return the item with updated dates
                        return {
                            ...item,
                            startDate: s_date,
                            endDate: e_date
                        };
                    }
                });
            }

            // setFi

            let filterPending = pendingData.filter(
                (item) => item.locationId === locId
            );

            // setFi
            setFilteredBookedData(
                insertTravelTime(
                    [...filteredbookedData, ...filterPending, ...filteredBlock],
                    provider.maxTravelTime
                )
            );

            let dataObj = {
                availability: [...filteredAvail],
                bookedData: [
                    ...filteredbookedData,
                    ...filterPending,
                    ...filteredBlock
                ],
                blockedData: [...filteredBlock]
            };
            setTimeTableData(dataObj);
            setRefreshPage(false);
        }
    };

    function getNextDayDate(date) {
        let nd = new Date(date);
        nd.setDate(nd.getDate() + 1);
        return nd;
    }
    const handleAdhocBookingFlowDialogOpen = () => {
        setOpenAddBookingDialog(true);
    };
    const handleAdminAdhocBookingFlowDialogOpen = () => {
        const currentTime = getCurrentTimeAdjustedToNextHour();
        const endTime = new Date(currentTime).setMinutes(
            currentTime.getMinutes() + cellDuration
        );
        setClickedCellProps((prevState) => ({
            ...prevState,
            startDate: currentTime,
            endDate: endTime,
            providerId: provider ? provider.id : null,
            locationId: locationId ? locationId : null
        }));

        const foundLocation = find(locations, { id: locationId });
        if (foundLocation && foundLocation.maxtraveltype) {
            setDetail({ selectedLocationId: "customerLocation" });
        } else {
            setDetail({ selectedLocationId: locationId });
        }
        setBookingProviderId(provider?.id);
        setBookingDateTime(currentTime);
        setShowBookingDetails(true);
    };
    const handleAdhocBookingFlowDialogClose = () => {
        setOpenAddBookingDialog(false);
    };

    const continueWarningHandler = () => {
        closeWarningModal();
        handleAdminAdhocBookingFlowDialogOpen();
    };

    function handleMsgClose(event, reason) {
        setShowSnackMsg(false);
    }

    const settingCellProps = (obj) => {
        setClickedCellProps(obj);
    };

    //eDate, prov
    const changeDateTimeCellProps = (sDate, providerId, locationId) => {
        setClickedCellProps((prevState) => ({
            ...prevState,
            startDate: sDate,
            providerId: providerId ? providerId : null,
            locationId: locationId ? locationId : null
        }));
    };

    const openLoading = () => {
        setIsLoading(true);
    };

    const closeLoading = () => {
        setIsLoading(false);
    };

    const openBlockModalHandler = () => {
        setBlockedTimeDialog(true);
    };

    const timeTableCellComponent = useCallback(
        (cellProps) => {
            return (
                <CustomTimeTableCell
                    {...cellProps}
                    provider={provider}
                    timeTableData={timeTableData}
                    openDialog={handleAdhocBookingFlowDialogOpen}
                    closeDialog={handleAdhocBookingFlowDialogClose}
                    settingCellProps={settingCellProps}
                    fromPath={props.fromPath}
                    openBlockModalHandler={openBlockModalHandler}
                    openWarningModal={openWarningModal}
                    closeWarningModal={closeWarningModal}
                    showWarningModal={showWarningModal}
                    locationId={locationId}
                    locations={locations}
                />
            );
        },
        [timeTableData]
    );
    const WeekViewTimeScaleLayout = (cellProps) => {
        return (
            <WeekView.TimeScaleLayout
                {...cellProps}
                style={{ maxWidth: "66px" }}
            />
        );
    };

    const CustomOpenButton = ({ onVisibilityToggle, text }) => {
        let customText = isDesktop
            ? customizeDate(text)
            : moment(text, "DD MMMM YYYY").format("MMMM");
        return (
            <Button
                variant={"outlined"}
                onClick={onVisibilityToggle}
                sx={{
                    "&:hover": { backgroundColor: "white" }
                }}
            >
                {customText}
            </Button>
        );
    };

    const CustomSwitcher = ({
        currentView,
        onChange,
        availableViews,
        openLoading
    }) => {
        return (
            <ThemeProvider theme={SchedulerTheme({ palette: themePalette })}>
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center"
                    }}
                >
                    <FormControl>
                        <InputLabel id="view-switcher">View</InputLabel>
                        {/* Other toolbar content */}
                        <Select
                            sx={{
                                display: "flex",
                                gap: "4px",
                                minWidth: "80px",
                                maxWidth: "80px"
                            }}
                            label="View"
                            labelId="view-switcher"
                            value={currentView.name}
                            onChange={async (event) => {
                                setIsLoading(true);
                                if (event.target.value === "Day") {
                                    localStorage.setItem(
                                        "displayCalendarAs",
                                        event.target.value
                                    );

                                    try {
                                        await getLocationsData(locationId);
                                    } finally {
                                        onChange(event.target.value);
                                    }
                                    setIsLoading(false);
                                }

                                if (event.target.value === "Week") {
                                    localStorage.setItem(
                                        "displayCalendarAs",
                                        event.target.value
                                    );
                                    try {
                                        await getLocationsData(locationId);
                                    } finally {
                                        onChange(event.target.value);
                                    }
                                    setIsLoading(false);
                                }
                            }}
                        >
                            {availableViews.map((view) => (
                                <MenuItem key={view.name} value={view.name}>
                                    {view.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {isVerifiedStaff && isDesktop && (
                        <Button
                            variant="contained"
                            onClick={handleAdminAdhocBookingFlowDialogOpen}
                            sx={{
                                maxHeight: "36px",
                                marginLeft: "18px",
                                paddingRight: "18px",
                                paddingLeft: "16px",
                                gap: "4px",
                                width: "150px",
                                /* Media query to hide the button for screens narrower than 1449px */
                                "@media screen and (max-width: 1449px)": {
                                    display: "none" // Hide the button */
                                }
                            }}
                        >
                            <AddIcon
                                sx={{
                                    color: "white",
                                    width: "18px",
                                    height: "18px"
                                }}
                            />
                            <Typography
                                sx={{
                                    marginTop: "2px",
                                    fontSize: "14px",
                                    fontWeight: "700",
                                    color: "white"
                                }}
                            >
                                Add Booking
                            </Typography>
                        </Button>
                    )}
                </Box>
            </ThemeProvider>
        );
    };

    const getUnavailabilityTimes = async (
        startDate,
        endDate,
        providerId,
        companyId
    ) => {
        const aProvider = await graphql(
            graphqlOperation(getProviderExtended, {
                id: providerId
            })
        );
        setProvider(aProvider.data.getProvider);
        setSelectedUserId(aProvider.data.getProvider.user.id);
        let unavblocks = await getUnavailabilityOfProviderScheduleList(
            {
                companyId: companyId,
                provider: aProvider.data.getProvider,
                startDate: startDate,
                endDate: endDate
            },
            setAllBlockedTimes
        );
        if (unavblocks && unavblocks.length > 0) {
            unavblocks = unavblocks.map((block) => ({
                ...block,
                company: mbxUser.company
            }));
        }

        return unavblocks;
    };

    const getBookings = async (
        startDate,
        endDate,
        providerId,
        providerTimezone
    ) => {
        let bookings = await getBookingsList(
            providerId,
            startDate,
            endDate,
            providerTimezone
        );

        return bookings;
    };

    const availOrblocked = async (providerId, locId, sDate, eDate) => {
        const filteredProvider = props.selectingProviderHandler(providerId);
        if (locId === "0") return;

        setAvailabilityError(false);
        const compId = loggedInUser.companyId;
        let availabilityObj = await _getAvailability({
            companyId: compId,
            providerArr: [filteredProvider]
        });

        let bookingsObj = await getBookings(
            sDate,
            eDate,
            filteredProvider.id,
            filteredProvider.timezone
        );

        let blockedObj = await getUnavailabilityTimes(
            sDate,
            eDate,
            providerId,
            compId
        );
        if (
            availabilityObj &&
            availabilityObj.availability &&
            availabilityObj.availability.length > 0
        ) {
            let filtered_avail = availabilityObj.availability.filter(
                (item) => item.locationId === locId
            );

            let filter_location = locations.filter((item) => item.id === locId);

            if (filtered_avail.length <= 0 || filter_location.length <= 0) {
                setAvailabilityError(true);
            }

            const userTz = filteredProvider.timezone;

            if (masterTimezone !== filteredProvider.timezone) {
                blockedObj = blockedObj.map((item) => ({
                    ...item,
                    startDate: timezoneConversionUserToLoc(
                        item.startDate,
                        filteredProvider.timezone,
                        masterTimezone
                    ),
                    endDate: timezoneConversionUserToLoc(
                        item.endDate,
                        filteredProvider.timezone,
                        masterTimezone
                    )
                }));
            }

            if (
                filter_location.length > 0 &&
                masterTimezone !== filter_location[0].timezone
            ) {
                const locTz =
                    locId && locId === "0"
                        ? userTz
                        : filter_location[0].timezone;

                filtered_avail = filtered_avail.map((item) => ({
                    ...item,
                    startDate: timezoneConversionUserToLoc(
                        item.startDate,
                        locTz,
                        masterTimezone
                    ),
                    endDate: timezoneConversionUserToLoc(
                        item.endDate,
                        locTz,
                        masterTimezone
                    )
                }));

                bookingsObj = bookingsObj.map((item) => ({
                    ...item,
                    startDate:
                        item.timezone !== masterTimezone
                            ? timezoneConversionUserToLoc(
                                  item.startDate,
                                  item.timezone,
                                  masterTimezone
                              )
                            : item.startDate,
                    endDate:
                        item.timezone !== masterTimezone
                            ? timezoneConversionUserToLoc(
                                  item.endDate,
                                  item.timezone,
                                  masterTimezone
                              )
                            : item.endDate
                }));
            }
            let sDate_tz = sDate;
            let isAvailable = false;

            for (const item of filtered_avail) {
                const rule = RRule.fromString(item.rRule);
                if (
                    checkForAvailabilityAndBlocked(
                        rule,
                        sDate_tz,
                        item.startDate,
                        item.endDate
                    )
                ) {
                    isAvailable = true;
                    break;
                }
            }

            if (!isAvailable) {
                setAvailabilityError(true);
                return;
            }

            //now checking if there is a block time exists
            //if there is no blocks, means length of array is zero, then check for bookings.
            let isBlocked = false;
            let isBooked = false;
            if (isAvailable && blockedObj && blockedObj.length > 0) {
                for (const item of blockedObj) {
                    if (item.servicetype.name === "Pending Booking") {
                        if (
                            checkForPending(
                                sDate_tz,
                                item.startDate,
                                item.endDate
                            )
                        ) {
                            isBlocked = true;
                            break;
                        }
                    }
                    if (item.servicetype.name === "Blocked") {
                        const rule = RRule.fromString(item.rRule);
                        if (
                            checkForAvailabilityAndBlocked(
                                rule,
                                sDate_tz,
                                item.startDate,
                                item.endDate
                            )
                        ) {
                            isBlocked = true;
                            break;
                        }
                    }
                }

                if (isBlocked) {
                    setAvailabilityError(true);
                    return;
                }

                if (!isBlocked && bookingsObj && bookingsObj.length > 0) {
                    //if spot is available and not blocked, now check if there is any booking
                    for (const item of bookingsObj) {
                        if (
                            checkForBooking(
                                sDate_tz,
                                item.startDate,
                                item.endDate
                            )
                        ) {
                            isBooked = true;
                            break;
                        }
                    }

                    if (isBooked) {
                        setAvailabilityError(true);
                        return;
                    }
                }
            } else {
                //this else is if there is no block

                if (bookingsObj && bookingsObj.length > 0) {
                    //if spot is available and not blocked, now check if there is any booking
                    for (const item of bookingsObj) {
                        if (
                            checkForBooking(
                                sDate_tz,
                                item.startDate,
                                item.endDate
                            )
                        ) {
                            isBooked = true;

                            break;
                        }
                    }

                    if (isBooked) {
                        setAvailabilityError(true);
                        return;
                    }
                }
            }
        } else {
            setAvailabilityError(true);
        }
    };

    function roundToNearestHalfHour(currentDate) {
        const adjustedDate = new Date(currentDate);
        const minutes = adjustedDate.getMinutes();
        const minutesToNextHalfHour = 30 - (minutes % 30);
        adjustedDate.setMinutes(minutes + minutesToNextHalfHour, 0);
        return adjustedDate;
    }

    const setTravelzoneTimezone = async (id, address) => {
        if (
            id === "0" &&
            address &&
            address.coords &&
            address.coords.lat &&
            address.coords.lng
        ) {
            let userTz = await getTimezoneIdByGeoLoc({
                lat: address.coords.lat,
                lng: address.coords.lng
            });
            return userTz;
        }
    };

    const resetAvailabilityError = () => {
        setAvailabilityError(false);
    };

    //prettier-ignore
    const CustomFlexibleSpace = ({
    setSelectedLocationId,
    cellDuration,
    locations,
    locationId,
    showLoc,
    displayListProviders,
    theme,
    isDesktop
}) => (
    <Box
        className="customFlexibleSpace"
        sx={{
            display: "flex",
            alignItems: "center",
            padding: "0px 18px",
            minWidth: localStorage?.displayCalendarAs === "day" ? "calc(100% - 545px)" : "calc(100% - 569px)",
            [theme.breakpoints.down('smallDesktop')]: {
                minWidth: localStorage?.displayCalendarAs === "day" ? "calc(100% - 377px)" : "calc(100% - 401px)",
                width: "100%",
            },
            [theme.breakpoints.down('md')]: {
                padding: "0px"
            }
        }}
    >
       
       <Grid
                item
                sx={{
                    display: "flex",
                    marginRight: "18px",
                    width: "44px"
                }}
            >
                <Button
                    variant="text"
                    onClick={() => setOpenLayoutDialog(true)}
                >
                    Layout
                </Button>
            </Grid>

            {openLayoutDialog && (
                <LayoutDialog
                    openLayoutDialog={openLayoutDialog}
                    onClose={() => setOpenLayoutDialog(false)}
                    defaultCellDuration={cellDuration}
                    onCellDurationChange={cellDurationChangeHandler}
                    defaultExcludedDays = {excludedDays}
                    onExcludedDaysChange={handleExcludedDaysChange}
                    defaultStartTimeBoundary={startDayHour}
                    defaultEndTimeBoundary={endDayHour}
                    onStartEndTimeChange={handleStartEndTimeChange}
                />
            )}
            
        {/* Coverage Areas and Providers */}
        <Grid
            item
            sx={{
                display: "flex",
                alignItems: "center",
                gap: "18px",
                width: "100%"
            }}
        >
            {displayListProviders.length !== 0 && isDesktop && (
                <FormControl
                    sx={{
                        width: "50%"
                    }}
                >
                    {displayListProviders("Provider")}
                </FormControl>
            )}
            <FormControl
                sx={{
                    width: displayListProviders.length !== 0 ? "50%" : "100%"
                }}
            >
                <InputLabel id="coverage-area">Coverage area</InputLabel>
                {/* Other toolbar content */}
                <Select
                    disabled={!showLoc}
                    labelId="coverage-area"
                    value={locationId}
                    label="Coverage area"
                    onChange={(e) => {
                        setSelectedLocationId(e);
                    }}
                >
                    {showLoc &&
                        locations.map((location, idx) => (
                            <MenuItem
                                value={location.id}
                                key={
                                    location && location.id ? location.id : idx
                                }
                            >
                                {location && location.maxtraveltype
                                    ? location.name
                                    : location.locationname}
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>

        </Grid>
    </Box>
);

    const themePalette = useTheme().palette;
    const classes = usePromotionsStyles();
    const [showBookingModal, setShowBookingModal] = useAtom(
        showBookingDetailsAtom
    );

    return (
        <>
            {!fullPageLoad ? (
                <>
                    <ThemeProvider
                        theme={SchedulerTheme({ palette: themePalette })}
                    >
                        <Grid
                            sx={{
                                display: "flex",
                                justifyContent: "space-between"
                            }}
                        >
                            <FormHeading title={"Calendar"} classes={classes} />
                            {isVerifiedStaff && isDesktop && (
                                <Button
                                    variant="contained"
                                    onClick={
                                        handleAdminAdhocBookingFlowDialogOpen
                                    }
                                    sx={{
                                        display: "none", // Hide the button by default
                                        paddingRight: "18px",
                                        paddingLeft: "16px",
                                        maxHeight: "36px",
                                        gap: "4px",
                                        minWidth: "150px",
                                        /* Media query to show the button for screens narrower than 1449px */
                                        "@media screen and (max-width: 1449px)":
                                            {
                                                display: "flex", // Display the button */
                                                position: "relative",
                                                alignSelf: "flex-end"
                                            }
                                    }}
                                >
                                    <AddIcon
                                        sx={{
                                            color: "white",
                                            width: "18px",
                                            height: "18px"
                                        }}
                                    />
                                    <Typography
                                        sx={{
                                            marginTop: "2px",
                                            fontSize: "14px",
                                            fontWeight: "700",
                                            color: "white"
                                        }}
                                    >
                                        Add Booking
                                    </Typography>
                                </Button>
                            )}
                        </Grid>
                    </ThemeProvider>
                    <Snackbar
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "center"
                        }}
                        open={msgOpen}
                        autoHideDuration={3000}
                        onClose={() => setMsgOpen(false)}
                        ContentProps={{
                            "aria-describedby": "message-id"
                        }}
                        message={<span id="message-id">{snackMsg}</span>}
                    />
                    <Box display={"flex"} justifyContent={"center"}>
                        <Backdrop
                            sx={{
                                color: "#fff",
                                zIndex: (theme) => theme.zIndex.drawer + 1
                            }}
                            open={isLoading || refreshPage}
                        >
                            <CircularProgress />
                        </Backdrop>
                    </Box>
                    <SmallSizedModal
                        open={showWarningModal}
                        onClose={closeWarningModal}
                        headingIcon={WarningTriangleIcon}
                        headingText={"No availability"}
                    >
                        <Box>
                            <Typography variant="body2">
                                The selected provider does not have availability
                                at this time. As an admin, you can override
                                this. Do you wish to continue?
                            </Typography>
                        </Box>
                        <Box
                            mt={2}
                            sx={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "1.25rem"
                            }}
                        >
                            <Button
                                sx={{
                                    height: "2.25rem",
                                    boxShadow: "none",
                                    minWidth: "5.625rem",
                                    alignItems: "center",
                                    borderColor: "primary.main",
                                    lineHeight: "inherit",
                                    "&:hover": {
                                        boxShadow: "none"
                                    }
                                }}
                                onClick={closeWarningModal}
                                variant="outlined"
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                        fontFamily: "Roboto",
                                        paddingTop: "0.1rem"
                                    }}
                                >
                                    Cancel
                                </div>
                            </Button>
                            <Button
                                sx={{
                                    height: "2.25rem",
                                    boxShadow: "none",
                                    minWidth: "5.625rem",
                                    alignItems: "center",
                                    lineHeight: "inherit",
                                    "&:hover": {
                                        boxShadow: "none"
                                    }
                                }}
                                variant="contained"
                                onClick={continueWarningHandler}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        height: "100%",
                                        fontSize: "0.875rem",
                                        fontWeight: 500,
                                        fontFamily: "Roboto",
                                        paddingTop: "0.1rem"
                                    }}
                                >
                                    Continue
                                </div>
                            </Button>
                        </Box>
                    </SmallSizedModal>
                    <AdhocBookingFlow
                        show={openAddBookingDialog}
                        showSnackMessage={showSnackMsg}
                        handleClose={handleAdhocBookingFlowDialogClose}
                        handleMessageClose={handleMsgClose}
                        clickedCellProps={clickedCellProps}
                        provider={provider}
                        company={props.company}
                        setBookingCompleted={setBookingCompleted}
                        changeDateTimeCellProps={changeDateTimeCellProps}
                        providersList={props.providersList}
                        selectingProviderHandler={availOrblocked}
                        selectedProvider={
                            props?.selectedProviders
                                ? props.selectedProviders
                                : null
                        }
                        availabilityError={availabilityError}
                        resetAvailabilityError={resetAvailabilityError}
                        selectedLoc={
                            selectedLoc
                                ? selectedLoc.maxtraveltype
                                    ? {
                                          id: "0",
                                          addressoneline: "Client address",
                                          locationname: "Client Location"
                                      }
                                    : selectedLoc
                                : selectedLoc
                        }
                        setTravelzoneTimezone={setTravelzoneTimezone}
                        masterTimezone={masterTimezone}
                        roundToNearestHalfHour={roundToNearestHalfHour}
                    />
                    {openCourseManifest && (
                        <ThemeProvider theme={DialogTheme(theme)}>
                            <CourseManifestModal
                                open={openCourseManifest}
                                onClose={() => setOpenCourseManifest(false)}
                            />
                        </ThemeProvider>
                    )}
                    {openBlockedTimeDialog && (
                        <ThemeProvider theme={DialogTheme(theme)}>
                            <BlockedTimeModal
                                open={openBlockedTimeDialog}
                                onClose={() => {
                                    setBlockedTimeDialog(false);
                                }}
                                startDateInitial={clickedCellProps?.startDate}
                                endDateInitial={clickedCellProps?.startDate}
                                handleSave={async () => {
                                    //TODO: change to an optimistic update when state management is rewritten
                                    // for now a reload
                                    const nextSunday = new Date();
                                    const prevMonday = new Date();
                                    setIsLoading(true);
                                    await fetchAvailability(
                                        prevMonday.setDate(
                                            prevMonday.getDate() -
                                                ((prevMonday.getDay() + 6) % 7)
                                        ),
                                        nextSunday.setDate(
                                            prevMonday.getDate() + 6
                                        )
                                    );
                                    setIsLoading(false);
                                }}
                            />
                        </ThemeProvider>
                    )}
                    <ThemeProvider
                        theme={SchedulerTheme({ palette: themePalette })}
                    >
                        <Scheduler
                            ref={schedulerRef}
                            data={filteredbookedData}
                            bookingCompleted={bookingCompleted}
                            firstDayOfWeek={1}
                        >
                            <ViewState
                                defaultCurrentDate={currentDate}
                                defaultCurrentViewName="Week"
                                currentViewName={
                                    localStorage?.displayCalendarAs &&
                                    props?.selectedProviders
                                        ? localStorage.displayCalendarAs
                                        : "Week"
                                }
                                onCurrentViewNameChange={changeViewName}
                                onCurrentDateChange={currentDateChanged}
                            />
                            <Toolbar
                                flexibleSpaceComponent={() => (
                                    <CustomFlexibleSpace
                                        theme={SchedulerTheme({
                                            palette: themePalette
                                        })}
                                        setSelectedLocationId={
                                            LocationIdChangeHandler
                                        }
                                        setCellDuration={
                                            cellDurationChangeHandler
                                        }
                                        cellDuration={cellDuration}
                                        locations={locations}
                                        locationId={locationId}
                                        openLoading={openLoading}
                                        closeLoading={closeLoading}
                                        showLoc={showLocDrop}
                                        showBookBtn={showBookBtn}
                                        displayListProviders={
                                            displayListProviders
                                        }
                                        isDesktop={isDesktop}
                                    />
                                )}
                            />
                            <WeekView
                                provider={provider}
                                cellDuration={cellDuration}
                                excludedDays={excludedDays}
                                displayName="Week"
                                startDayHour={startDayHour ?? 7}
                                endDayHour={endDayHour ?? 19}
                                timeTableCellComponent={timeTableCellComponent}
                                timeScaleLayoutComponent={
                                    WeekViewTimeScaleLayout
                                }
                            />
                            <DayView
                                provider={provider}
                                cellDuration={cellDuration}
                                startDayHour={startDayHour ?? 7}
                                endDayHour={endDayHour ?? 19}
                                timeTableCellComponent={timeTableCellComponent}
                            />

                            <DateNavigator
                                openButtonComponent={CustomOpenButton}
                                {...(!isDesktop && {
                                    navigationButtonComponent: () => (
                                        <Button sx={{ display: "none" }} />
                                    )
                                })}
                            />
                            {isDesktop && <TodayButton />}
                            {isDesktop && (
                                <ViewSwitcher
                                    switcherComponent={CustomSwitcher}
                                    openLoading={openLoading}
                                />
                            )}
                            <Appointments
                                appointmentComponent={(props) => (
                                    <Appointment
                                        {...props}
                                        changeDateTimeCellProps={
                                            changeDateTimeCellProps
                                        }
                                        cellDuration={cellDuration}
                                        openBlockModalHandler={
                                            openBlockModalHandler
                                        }
                                        openCourseManifest={
                                            setOpenCourseManifest
                                        }
                                    />
                                )}
                                appointmentContentComponent={(props) => (
                                    <AppointmentContent
                                        {...props}
                                        cellDuration={cellDuration}
                                        getCourseCapacityMessage={
                                            getCourseCapacityMessage
                                        }
                                        getCourseName={getCourseName}
                                    />
                                )}
                            ></Appointments>
                            {
                                <AppointmentTooltip
                                    headerComponent={AppointmentTooltipHeader}
                                    contentComponent={AppointmentTooltipContent}
                                    showCloseButton
                                ></AppointmentTooltip>
                            }
                        </Scheduler>
                    </ThemeProvider>
                    <AdhocBookingFlow
                        show={openAddBookingDialog}
                        showSnackMessage={showSnackMsg}
                        handleClose={handleAdhocBookingFlowDialogClose}
                        handleMessageClose={handleMsgClose}
                        clickedCellProps={clickedCellProps}
                        provider={provider}
                        company={props.company}
                        setBookingCompleted={setBookingCompleted}
                        changeDateTimeCellProps={changeDateTimeCellProps}
                        providersList={props.providersList}
                        selectingProviderHandler={availOrblocked}
                        selectedProvider={
                            props?.selectedProviders
                                ? props.selectedProviders
                                : null
                        }
                        availabilityError={availabilityError}
                        resetAvailabilityError={resetAvailabilityError}
                        selectedLoc={
                            selectedLoc
                                ? selectedLoc.maxtraveltype
                                    ? {
                                          id: "0",
                                          addressoneline: "Client address",
                                          locationname: "Client Location"
                                      }
                                    : selectedLoc
                                : selectedLoc
                        }
                        setTravelzoneTimezone={setTravelzoneTimezone}
                        masterTimezone={masterTimezone}
                        roundToNearestHalfHour={roundToNearestHalfHour}
                    />
                </>
            ) : (
                <>
                    <Backdrop
                        sx={{
                            color: "#fff",
                            zIndex: (theme) => theme.zIndex.drawer + 1
                        }}
                        open={fullPageLoad}
                    >
                        <CircularProgress />
                    </Backdrop>
                    <ThemeProvider theme={SchedulerTheme}>
                        <Grid
                            sx={{
                                display: "flex",
                                justifyContent: "space-between"
                            }}
                        >
                            <FormHeading title={"Calendar"} classes={classes} />
                            {isVerifiedStaff && isDesktop && (
                                <Button
                                    variant="contained"
                                    sx={{
                                        display: "none", // Hide the button by default
                                        paddingRight: "18px",
                                        paddingLeft: "16px",
                                        maxHeight: "36px",
                                        gap: "4px",
                                        minWidth: "150px",
                                        /* Media query to show the button for screens narrower than 1449px */
                                        "@media screen and (max-width: 1449px)":
                                            {
                                                display: "flex", // Display the button */
                                                position: "relative",
                                                alignSelf: "flex-end"
                                            }
                                    }}
                                >
                                    <AddIcon
                                        sx={{
                                            color: "white",
                                            width: "18px",
                                            height: "18px"
                                        }}
                                    />
                                    <Typography
                                        sx={{
                                            marginTop: "2px",
                                            fontSize: "14px",
                                            fontWeight: "700",
                                            color: "white"
                                        }}
                                    >
                                        Add Booking
                                    </Typography>
                                </Button>
                            )}
                        </Grid>
                    </ThemeProvider>
                    {displayEmptyScheduler()}
                </>
            )}
            <NotificationSnackbar
                open={openSnackbar}
                severity={snackSeverity}
                message={snackMessage}
                onClose={handleCloseSnackbar}
            />
        </>
    );
};
